import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later.
const firebaseConfig = {
  apiKey: "AIzaSyALYBGG6Tp4om5cF9JZBwUrwKn2kDn7RSg",
  authDomain: "al-maha-island.firebaseapp.com",
  projectId: "al-maha-island",
  storageBucket: "al-maha-island.appspot.com",
  messagingSenderId: "158050204509",
  appId: "1:158050204509:web:a833b9d23522ab25fec6b4",
  measurementId: "G-R5N9G69QQN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const trackFBEvent = (label = "event", body = {}) => {
  try {
    logEvent(analytics, `${label}_web`, { ...body, from: "website" }); // FIREBASE
    window.dataLayer.push({
      event: `${label}_web`,
      ...body,
      from: "website",
    }); // GTM
  } catch (err) {
    console.log(err);
  }
};
